import fetch from '@/utils/fetch'

// 通知列表
export function getMessagePage(params) {
  return fetch({
    url: '/api/artificial/abnl/message/staff/list',
    method: 'get',
    params
  })
}

// 标记已读
export function markMessageRead(msgId) {
  return fetch({
    url: '/api/artificial/abnl/message/read',
    method: 'put',
    params: {
      msgId
    }
  })
}